<template>
  <div>
    <file-library
      :allowedFiles="'*'"
      :key="selectedFile.id"
      ref="fileLibrary"
      :value="selectedFile"
      @selected="
        updateItem({
          title: $event.name,
          value: JSON.stringify($event),
        })
      "
      @opened="fileLibraryOpened"
      @closed="fileLibraryClosed"
    />
    <div class="section-paragraph space-y-5">
      <div
        v-for="(file, index) in list"
        :key="index"
        class="flex justify-between"
      >
        <div
          class="flex space-x-2 text-base"
          :class="[!isPreview ? 'cursor-pointer' : '']"
          :title="!isPreview ? 'Click to edit' : ''"
          @click="!isPreview ? openEditItemPopup(file, index) : () => {}"
        >
          <div
            class="
              w-6
              h-6
              icon-bg-blue
              text-white
              btn-radius
              flex
              justify-center
              items-center
            "
          >
            <i
              class="far text-sm"
              :class="
                getFontAwesomeIconFromMIME(JSON.parse(file.value).mime_type)
              "
              aria-hidden="true"
            ></i>
          </div>
          <div class="flex-1">{{ file.title }}</div>
          <div class="text-grey-700">
            {{ JSON.parse(file.value).size }}
          </div>
          <div
            v-if="!isPreview"
            class="text-grey-500 cursor-pointer"
            :title="!isPreview ? 'Remove' : ''"
            @click.stop="deleteItem(index)"
          >
            <i class="fa fa-times"></i>
          </div>
        </div>
        <div @click="downloadFile(file)">
          <span class="download-icon"></span>
        </div>
      </div>
      <div
        v-if="!isPreview"
        @click="openAddItemPopup()"
        class="text-pink md:text-xl text-base font-semibold cursor-pointer"
      >
        + Add Item
      </div>
    </div>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import FileLibraryMixin from '../custom-popup/file-library/mixin';

export default {
  name: 'Download',
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    index: {},
    getThemeSettings: {},
    content: {
      type: Object,
      required: true,
    },
  },
  mixins: [FileLibraryMixin],
  computed: {
    list() {
      return this.content.items;
    },
    viewType() {
      return this.content.viewType;
    },
    showInSidebar() {
      return this.content.showInSidebar;
    },
  },
  methods: {
    updateViewType(viewType) {
      const items = cloneDeep(this.list);

      this.$emit('updateSectionContent', { viewType, showInSidebar, items });
    },
    updateItem(item) {
      try {
        const items = cloneDeep(this.list);
        this.editingItemIndex < 0
          ? items.push(item)
          : (items[this.editingItemIndex] = item);

        this.$emit('updateSectionContent', {
          viewType: this.viewType,
          showInSidebar: this.showInSidebar,
          items,
        });
      } catch (err) {
        /** */
      }
    },
    deleteItem(index) {
      const items = cloneDeep(this.list);
      items.splice(index, 1);

      this.$emit('updateSectionContent', {
        viewType: this.viewType,
        showInSidebar: this.showInSidebar,
        items,
      });
    },
  },
};
</script>
<style lang="scss">
.icon-bg-blue {
  background: #0047ff;
}
.download-icon {
  width: 30px;
  height: 28px;
  position: relative;
  top: -1px;
  display: block;
  &::after {
    top: 0px;
    right: 0px;
    position: absolute;
    width: 22px;
    height: 22px;
    background: url('../../../../../assets/images/icons/download.png');
    display: inline-block;
    content: '';
    outline: none;
    color: #fff;
    cursor: pointer;
  }
}
</style>
